import store from '../store'

export default{
    symbole(idUnite) {
        if (!idUnite) return ''
        let unite = store.getters.getUnite(idUnite)
        if (!unite) return ''
        return unite.symbole
    },
    libelle(idUnite) {
        if (!idUnite) return ''
        let unite = store.getters.getUnite(idUnite)
        if (!unite) return ''
        return unite.libLong
    }
}